(function () {
  'use strict';

  window.TDCUtils = {
    formatMoney: function (cents) {
      if (cents == null) return '$0';
      if (typeof cents === 'string') {
        if (cents.indexOf('$') !== -1) return cents;
        var parsed = parseFloat(cents);
        if (!isNaN(parsed)) {
          return '$' + (parsed % 1 ? parsed.toFixed(2) : parsed.toFixed(0));
        }
        return cents;
      }
      if (typeof cents === 'number') {
        var dollars = cents / 100;
        return '$' + (dollars % 1 ? dollars.toFixed(2) : dollars.toFixed(0));
      }
      return '$0';
    },

    esc: function (t) {
      if (t == null) return '';
      return String(t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    },

    highlight: function (text, q) {
      if (!q) return this.esc(text);
      var i = text.toLowerCase().indexOf(q.toLowerCase());
      if (i < 0) return this.esc(text);
      return this.esc(text.slice(0, i)) + '<mark>' + this.esc(text.slice(i, i + q.length)) + '</mark>' + this.esc(text.slice(i + q.length));
    },

    getFocusableElements: function (el) {
      return Array.prototype.filter.call(
        el.querySelectorAll('a[href], button:not([disabled]), input, textarea, select, summary, [tabindex]:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null; }
      );
    },

    trapFocus: function (el) {
      var focusables = this.getFocusableElements(el);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      function handleTab(e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      el.addEventListener('keydown', handleTab);
      first.focus({ preventScroll: true });

      return function () {
        el.removeEventListener('keydown', handleTab);
      };
    },

    debounce: function (fn, delay) {
      var timer = null;
      return function () {
        var args = arguments;
        var ctx = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(ctx, args);
        }, delay);
      };
    },

    resizeImageUrl: function (url, size) {
      if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
      return url.replace(/(\.[a-z]+)(\?|$)/, '_' + size + 'x$1$2');
    }
  };

  var toastTimer;
  var toastRegion;

  function dismissToast(toast) {
    if (!toast) return;
    toast.classList.remove('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
  }

  function showToast(type, message, title) {
    if (!document.body) return;
    if (!toastRegion) {
      toastRegion = document.createElement('div');
      toastRegion.id = 'tdc-toast-region';
      toastRegion.className = 'tdc-toast-region';
      toastRegion.setAttribute('aria-label', 'Notifications');
      document.body.appendChild(toastRegion);
    }

    var toast = document.createElement('div');
    toast.className = 'tdc-toast tdc-toast--' + type;
    toast.setAttribute('role', type === 'warning' ? 'alert' : 'status');

    var icon = document.createElement('span');
    icon.className = 'tdc-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = type === 'warning' ? '!' : '✓';

    var copy = document.createElement('span');
    copy.className = 'tdc-toast__copy';
    if (title) {
      var heading = document.createElement('strong');
      heading.className = 'tdc-toast__title';
      heading.textContent = title;
      copy.appendChild(heading);
    }
    var text = document.createElement('span');
    text.className = 'tdc-toast__message';
    text.textContent = message;
    copy.appendChild(text);

    var close = document.createElement('button');
    close.className = 'tdc-toast__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss notification');
    close.textContent = '×';
    close.addEventListener('click', function () {
      dismissToast(toast);
    });

    toast.appendChild(icon);
    toast.appendChild(copy);
    toast.appendChild(close);
    toastRegion.replaceChildren(toast);

    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      dismissToast(toast);
    }, 5000);
  }

  window.TDCToast = {
    warning: function (message, title) {
      showToast('warning', message, title);
    },
    success: function (message, title) {
      showToast('success', message, title);
    }
  };
})();

/* ================================================================
   TDCCartGuard — Optimistic Cart Quantity Tracker
   ================================================================
   Prevents rapid-click double-adds by maintaining an in-flight
   pending quantity map that is checked BEFORE each AJAX call.

   Usage:
     // Before add:
     var ok = TDCCartGuard.canAdd(variantId, qty, invLimit);
     if (!ok) { show error; return; }
     TDCCartGuard.reserve(variantId, qty);        // lock the qty

     // On success:
     TDCCartGuard.confirm(variantId, qty);        // release after cart refresh

     // On error:
     TDCCartGuard.release(variantId, qty);        // release on failure

     // Effective qty = cart qty + in-flight pending qty:
     TDCCartGuard.getEffectiveCartQty(variantId)
================================================================ */
(function () {
  'use strict';

  // Map of variantId → pending quantity (reserved but not yet confirmed by cart API)
  var _pending = {};

  function getConfirmedCartQty(variantId) {
    if (!variantId) return 0;
    var cart = (window.TDCCart && window.TDCCart.currentCart) || window._themeCart || null;
    if (cart && cart.items) {
      var item = cart.items.find(function (i) {
        return String(i.id) === String(variantId) || String(i.variant_id) === String(variantId);
      });
      if (item) return parseInt(item.quantity, 10) || 0;
    }
    return 0;
  }

  function getPending(variantId) {
    return parseInt(_pending[String(variantId)] || 0, 10);
  }

  window.TDCCartGuard = {
    /**
     * Returns the effective cart quantity = confirmed + pending in-flight.
     */
    getEffectiveCartQty: function (variantId) {
      return getConfirmedCartQty(variantId) + getPending(variantId);
    },

    /**
     * Returns true if adding `qty` units is within `invLimit`.
     * Pass invLimit = Infinity (or omit) for unlimited products.
     */
    canAdd: function (variantId, qty, invLimit) {
      qty = qty || 1;
      if (invLimit == null || invLimit === Infinity || invLimit < 0) return true;
      var effective = this.getEffectiveCartQty(variantId);
      return (effective + qty) <= invLimit;
    },

    /**
     * Reserve `qty` units as in-flight (call immediately before fetch).
     */
    reserve: function (variantId, qty) {
      qty = qty || 1;
      var key = String(variantId);
      _pending[key] = (getPending(variantId)) + qty;
    },

    /**
     * Release reserved qty after success (cart will now reflect real qty).
     */
    confirm: function (variantId, qty) {
      this.release(variantId, qty);
    },

    /**
     * Release reserved qty on failure (undo the reserve).
     */
    release: function (variantId, qty) {
      qty = qty || 1;
      var key = String(variantId);
      _pending[key] = Math.max(0, getPending(variantId) - qty);
      if (_pending[key] === 0) delete _pending[key];
    },

    /**
     * Reset all pending for a variant (e.g. after cart fully refreshed).
     */
    reset: function (variantId) {
      if (variantId) {
        delete _pending[String(variantId)];
      } else {
        _pending = {};
      }
    }
  };
})();